// Component from https://reactjs.org/docs/error-boundaries.html
import React from 'react'
import styled from '@emotion/styled'

const FooterContainer = styled('div')(() => ({
  height: '100px',
  margin: '0px',
  padding: '2rem',
  width: '100%',
  display: 'flex',
  backgroundColor: '#561651',
  color: '#fff',
  marginTop: '1rem',
  '& span': {
    background: '#fafafa',
    padding: '0 20px',
  },
}))
const HeaderContainer = styled('div')(() => ({
  height: '100px',
  margin: '0px',
  padding: '2rem',
  width: '100%',
  display: 'flex',
  backgroundColor: '#561651',
  color: '#FFF',
  textAlign: 'center',
}))
const BodyContainer = styled('div')(() => ({
  flex: '1',
  margin: '0px',
  padding: '2rem',
  width: '100%',
  display: 'flex',
  backgroundColor: '#FFF',
  color: '#561651',
  textAlign: 'center',
  flexDirection: 'column',
}))
const RootContainer = styled('div')(() => ({
  margin: '0px',
  padding: '0px',
  width: '100vw',
  maxWidth: '100vw',
  height: '100vh',
  maxHeight: '100vh',
  display: 'flex',
  color: '#fff',
  overflow: 'scroll',
  textAlign: 'center',
  flexDirection: 'column',
}))

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error?.message,
      errorInfo: errorInfo,
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <RootContainer>
          <HeaderContainer>
            <h2 style={{ margin: 'auto' }}>Something went wrong.</h2>
          </HeaderContainer>
          <BodyContainer>
            <h1 style={{ margin: 'auto' }}>
              {this.state.error && this.state.error}
            </h1>
            <br />
            <h4>{this.state.errorInfo?.componentStack}</h4>
          </BodyContainer>
          <FooterContainer>
            <div style={{ margin: 'auto' }}>
              For help please contact us at: U.S. Tel. +1 (786) 206.6147
              Mex.Tel. +52 (222) 944.3402
            </div>
          </FooterContainer>
        </RootContainer>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
